import { createSelector } from "@reduxjs/toolkit";
import useViewsSelector from "views/stores/useViewsSelector";
import { selectActiveQuery, selectView } from "views/logic/slices/viewSelectors";
const selectViewMetadata = createSelector(
  selectActiveQuery,
  selectView,
  (activeQuery, view) => view ? {
    id: view == null ? void 0 : view.id,
    title: view == null ? void 0 : view.title,
    description: view == null ? void 0 : view.description,
    summary: view == null ? void 0 : view.summary,
    activeQuery
  } : {}
);
const useViewMetadata = () => useViewsSelector(selectViewMetadata);
export default useViewMetadata;
